module.exports = __webpack_public_path__ + "img/About_Us_Header_Picture.2c9c4c16.png";